import { Location } from '@angular/common';
import { inject } from '@angular/core';
import { CanDeactivateFn, Router } from '@angular/router';
import { WindowRef } from '@planone/shared/util-browser-api';

export const ScrollPositionGuard: CanDeactivateFn<boolean> = () => {
  const location = inject(Location);
  const windowRef = inject(WindowRef);
  const router = inject(Router);

  const pathnameSplit = router.url.split('?');
  const pathnameRouter = pathnameSplit[0];
  const pathnameGet = pathnameSplit[1]?.split('&scrollposition=')[0]?.split('?scrollposition=')[0];

  location.replaceState(
    pathnameRouter +
      '?' +
      (pathnameGet ? pathnameGet + '&' : '') +
      'scrollposition=' +
      Math.trunc(windowRef.nativeWindow.scrollY)
  );

  return true;
};
